/* What the four charts share. Rounded, bold and never sharp-edged. */
import React from 'react';

/**
 * Monotone smooth SVG path through points (never overshoots).
 *
 * @param {[number, number][]} pts
 * @returns {string}
 */
function smooth(pts) {
  if (pts.length < 2) return '';
  if (pts.length === 2) return `M${pts[0][0]},${pts[0][1]}L${pts[1][0]},${pts[1][1]}`;
  const n = pts.length, dx = [], dy = [], m = [], t = [];
  for (let i = 0; i < n - 1; i++) { dx[i] = pts[i + 1][0] - pts[i][0]; dy[i] = pts[i + 1][1] - pts[i][1]; m[i] = dy[i] / dx[i]; }
  t[0] = m[0]; t[n - 1] = m[n - 2];
  for (let i = 1; i < n - 1; i++) t[i] = m[i - 1] * m[i] <= 0 ? 0 : (3 * (dx[i - 1] + dx[i])) / ((2 * dx[i] + dx[i - 1]) / m[i - 1] + (dx[i] + 2 * dx[i - 1]) / m[i]);
  let d = `M${pts[0][0].toFixed(1)},${pts[0][1].toFixed(1)}`;
  for (let i = 0; i < n - 1; i++) { const h3 = dx[i] / 3; d += `C${(pts[i][0] + h3).toFixed(1)},${(pts[i][1] + t[i] * h3).toFixed(1)} ${(pts[i + 1][0] - h3).toFixed(1)},${(pts[i + 1][1] - t[i + 1] * h3).toFixed(1)} ${pts[i + 1][0].toFixed(1)},${pts[i + 1][1].toFixed(1)}`; }
  return d;
}
export { smooth as smoothPath };

/* the chart follows its container, measured rather than guessed */
export const useWidth = (ref, fallback) => { const [w, setW] = React.useState(0); React.useLayoutEffect(() => { const el = ref.current; if (!el) return; const f = () => setW(el.clientWidth || fallback); f(); let ro; try { ro = new ResizeObserver(f); ro.observe(el); } catch (e) {} return () => ro && ro.disconnect(); }, []); return w; };

/** The chart fills, by tone. */
export const TONEFILL = { lime: 'var(--lime)', gold: 'var(--gold)', coral: 'var(--coral)', blue: 'var(--chart-4)', purple: 'var(--chart-5)', ink: 'var(--inkbg)', track: 'var(--track)' };
